module.exports = __webpack_public_path__ + "5d95d441af0671e1ac3bff74ebc6716c.MP3";